module.exports = __webpack_public_path__ + "images/Qudian-27dd8a.png";